module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-up-left-7d84ad0460eea2890921fcb0a19ac5c9.svg";